import { AiVideoContinuitySections } from '../components/use-cases/AiVideoContinuitySections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildAiVideoContinuityPageSchema } from '../lib/schema';
import { AI_VIDEO_CONTINUITY_META } from '../lib/seo';
import '../styles/product-landing.css';
import '../styles/solutions-landing.css';

export function AiVideoContinuityPage() {
  return (
    <>
      <PageSeo meta={AI_VIDEO_CONTINUITY_META} />
      <JsonLd data={buildAiVideoContinuityPageSchema()} />
      <MarketingLandingShell>
        <AiVideoContinuitySections />
      </MarketingLandingShell>
    </>
  );
}
